<!--City dropdown-->
<div *ngIf="column.cityDropdown" class="filterheight overflow-auto">
  
    <ul class="list-group">
      <li class="list-group-item filter-header">Filters</li> 
      <li class="list-group-item">
        <span>
          <span class="icon-ic_checkbox" *ngIf="selectAllCityType.isChecked"
            (click)="selectAllCityType.isChecked = false;selectAllCityTypeFilter(selectAllCityType.isChecked)"></span>
          <span class="icon-ic_checkbox_all" *ngIf="!selectAllCityType.isChecked"
            (click)="selectAllCityType.isChecked = true;selectAllCityTypeFilter(selectAllCityType.isChecked)"></span>
          <span class="ml-2"
            (click)="selectAllCityType.isChecked = !selectAllCityType.isChecked; selectAllCityTypeFilter(selectAllCityType.isChecked)">All</span>
        </span>
      </li>
      <li class="list-group-item" *ngFor="let tyarray of cityArray">
        <span>
          <span class="icon-ic_checkbox" *ngIf="tyarray.isCheck" (click)="tyarray.isCheck=false;togglefilter(cityArray,selectAllCityType,tyarray.isCheck)"></span>
          <span class="icon-ic_checkbox_unexpected" *ngIf="!tyarray.isCheck" (click)="tyarray.isCheck=true;togglefilter(cityArray,selectAllCityType,tyarray.isCheck)"></span>
          <span class="ml-2" (click)="tyarray.isCheck = !tyarray.isCheck;togglefilter(cityArray,selectAllCityType,tyarray.isCheck)">{{tyarray.description}}</span>
        </span>
      </li>
    </ul>
  </div>

<!--Role dropdown-->
<div *ngIf="column.roleDropdown" class="filterheight overflow-auto">
  
    <ul class="list-group">
      <li class="list-group-item filter-header">Filters</li> 
      <li class="list-group-item">
        <span>
          <span class="icon-ic_checkbox" *ngIf="selectAllRoleType.isChecked"
            (click)="selectAllRoleType.isChecked = false;selectAllRoleTypeFilter(selectAllRoleType.isChecked)"></span>
          <span class="icon-ic_checkbox_all" *ngIf="!selectAllRoleType.isChecked"
            (click)="selectAllRoleType.isChecked = true;selectAllRoleTypeFilter(selectAllRoleType.isChecked)"></span>
          <span class="ml-2"
            (click)="selectAllRoleType.isChecked = !selectAllRoleType.isChecked; selectAllRoleTypeFilter(selectAllRoleType.isChecked)">All</span>
        </span>
      </li>
      <li class="list-group-item" *ngFor="let tyarray of roleArray">
        <span>
          <span class="icon-ic_checkbox" *ngIf="tyarray.isCheck" (click)="tyarray.isCheck=false;togglefilter(roleArray,selectAllRoleType,tyarray.isCheck)"></span>
          <span class="icon-ic_checkbox_unexpected" *ngIf="!tyarray.isCheck" (click)="tyarray.isCheck=true;togglefilter(roleArray,selectAllRoleType,tyarray.isCheck)"></span>
          <span class="ml-2" (click)="tyarray.isCheck = !tyarray.isCheck;togglefilter(roleArray,selectAllRoleType,tyarray.isCheck)">{{tyarray.description}}</span>
        </span>
      </li>
    </ul>
  </div>

<!--Office dropdown-->
<div *ngIf="column.officeDropdown" class="filterheight overflow-auto">
  
    <ul class="list-group">
      <li class="list-group-item filter-header">Filters</li> 
      <li class="list-group-item">
        <span>
          <span class="icon-ic_checkbox" *ngIf="selectAllOfficeType.isChecked"
            (click)="selectAllOfficeType.isChecked = false;selectAllOfficeTypeFilter(selectAllOfficeType.isChecked)"></span>
          <span class="icon-ic_checkbox_all" *ngIf="!selectAllOfficeType.isChecked"
            (click)="selectAllOfficeType.isChecked = true;selectAllOfficeTypeFilter(selectAllOfficeType.isChecked)"></span>
          <span class="ml-2"
            (click)="selectAllOfficeType.isChecked = !selectAllOfficeType.isChecked; selectAllOfficeTypeFilter(selectAllOfficeType.isChecked)">All</span>
        </span>
      </li>
      <li class="list-group-item" *ngFor="let tyarray of officeArray">
        <span>
          <span class="icon-ic_checkbox" *ngIf="tyarray.isCheck" (click)="tyarray.isCheck=false;togglefilter(officeArray,selectAllOfficeType,tyarray.isCheck)"></span>
          <span class="icon-ic_checkbox_unexpected" *ngIf="!tyarray.isCheck" (click)="tyarray.isCheck=true;togglefilter(officeArray,selectAllOfficeType,tyarray.isCheck)"></span>
          <span class="ml-2" (click)="tyarray.isCheck = !tyarray.isCheck;togglefilter(officeArray,selectAllOfficeType,tyarray.isCheck)">{{tyarray.description}}</span>
        </span>
      </li>
    </ul>
  </div>
  

  <!--Status dropdown-->
<div *ngIf="column.statusDropdown" class="filterheight overflow-auto">
  
  <ul class="list-group">
    <li class="list-group-item filter-header">Filters</li> 
    <li class="list-group-item">
      <span>
        <span class="icon-ic_checkbox" *ngIf="selectAllStatusType.isChecked"
          (click)="selectAllStatusType.isChecked = false;selectAllStatusTypeFilter(selectAllStatusType.isChecked)"></span>
        <span class="icon-ic_checkbox_all" *ngIf="!selectAllStatusType.isChecked"
          (click)="selectAllStatusType.isChecked = true;selectAllStatusTypeFilter(selectAllStatusType.isChecked)"></span>
        <span class="ml-2"
          (click)="selectAllStatusType.isChecked = !selectAllStatusType.isChecked; selectAllStatusTypeFilter(selectAllStatusType.isChecked)">All</span>
      </span>
    </li>
    <li class="list-group-item" *ngFor="let tyarray of statusArray">
      <span>
        <span class="icon-ic_checkbox" *ngIf="tyarray.isCheck" (click)="tyarray.isCheck=false;togglefilter(officeArray,selectAllStatusType,tyarray.isCheck)"></span>
        <span class="icon-ic_checkbox_unexpected" *ngIf="!tyarray.isCheck" (click)="tyarray.isCheck=true;togglefilter(officeArray,selectAllStatusType,tyarray.isCheck)"></span>
        <span class="ml-2" (click)="tyarray.isCheck = !tyarray.isCheck;togglefilter(officeArray,selectAllStatusType,tyarray.isCheck)">{{tyarray.description}}</span>
      </span>
    </li>
  </ul>
</div>

  
  <!--Buttons-->
  <!--Reset-->
  <div class="d-flex justify-content-between mx-2 mt-3 mb-3">
    <button (click)="resetEvents()" class="button sm" type="button">
      Cancel
    </button>
    <button (click)="onFilterApply(column)" class="button blue smblue" style="float: right;" type="button">
      Apply
    </button>
  </div>

  